module.exports = "https://pm2019.reeltime.no/public/images/qm-03.e37b83c1.png";